import React, { useEffect, useState } from "react";

const ListSiswa = ({ listSiswa, idJadwalCbt, urlSiswaReporting, urlSiswaReportKU }) => {
    return (
        <table className="table table-stripped">
            <thead>
                <th width="5%">No</th>
                <th>Nama</th>
                <th width="10%">Reporting</th>
                <th width="10%">Report KU</th>
            </thead>
            <tbody>
                {listSiswa.map((siswa, i) => (
                    <tr>
                        <td>{i + 1}</td>
                        <td>{siswa.namaSiswa}</td>
                        <td>
                            {siswa.statusAkademik && siswa.statusNonAkademik ? (
                                <a className="btn btn-info" title="Report siswa" href={urlSiswaReporting + idJadwalCbt + "/" + siswa.idSiswa} target="_blank">
                                    <li className="fa fa-print"></li>
                                </a>
                            ) : (
                                <button className="btn btn-danger" title="Belum selesai" aria-hidden="true">
                                    <li className="fa fa-eye-slash"></li>
                                </button>
                            )}
                        </td>
                        <td>
                            {siswa.statusAkademik && siswa.statusNonAkademik ? (
                                <a className="btn btn-primary" title="Report siswa" href={urlSiswaReportKU + siswa.idSiswa + "/" + idJadwalCbt} target="_blank">
                                    <li className="fa fa-print"></li>
                                </a>
                            ) : (
                                <button className="btn btn-danger" title="Belum selesai" aria-hidden="true">
                                    <li className="fa fa-eye-slash"></li>
                                </button>
                            )}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default ListSiswa;
